export default "__VITE_ASSET__ChL1Diq3__"